import type {
  CommitOptions,
  DispatchOptions,
  Module,
  Store as VuexStore,
} from "vuex/types/index.js";

import type { RootState } from "@/store";
import { type Actions, actions } from "./actions";
import { type Getters, getters } from "./getters";
import { type Mutations, mutations } from "./mutations";
import { state, type State } from "./state";

export type { State };

//setup store type
export type Store<S = State> = Omit<
  VuexStore<S>,
  "commit" | "getters" | "dispatch"
> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions
  ): ReturnType<Mutations[K]>;
} & {
  getters: {
    [K in keyof Getters]: ReturnType<Getters[K]>;
  };
} & {
  dispatch<K extends keyof Actions>(
    key: K,
    payload: Parameters<Actions[K]>[1],
    options?: DispatchOptions
  ): ReturnType<Actions[K]>;
};

export const OrderModule: Module<State, RootState> = {
  state,
  mutations,
  actions,
  getters,
};
